import useDoesPeppolVerificationRequiresAction from 'hooks/Peppol/useDoesPeppolVerificationRequiresAction';
import { FC } from 'react';
import NavigationItem from './NavigationItem.component';
import { SidebarNavigationItemTypesEnum } from './types';
import PeppolIcon from 'assets/svg/icons/PeppolIcon';
import classNames from 'classnames';
import { isWeb } from 'utils/constants';
import { WEBAPP_GLOBAL_CLICKEDPEPPOLFROMSIDEBAR } from 'utils/amplitude/events/global.amplitude';

export const PeppolNavigationItem: FC = () => {
  const requiresAction = useDoesPeppolVerificationRequiresAction({
    enabled: isWeb,
  });

  if (!requiresAction) return null;

  return (
    <NavigationItem
      item={{
        title: 'e_invoicing',
        tooltip: 'e_invoicing_menu_link_tooltip',
        to: '/settings/peppol',
        tracingEvent: WEBAPP_GLOBAL_CLICKEDPEPPOLFROMSIDEBAR,
        type: SidebarNavigationItemTypesEnum.peppol,
        Icon: (props) => (
          <PeppolIcon
            {...props}
            className={classNames(props.className, 'p-0.5')}
          />
        ),
      }}
    />
  );
};
